export const environment = {
  production: false,
  genAi: {
    // apiKey is injected at runtime by setting window.__GENAI_KEY__ or replaced during build
    apiKey: "AIzaSyCa-yVXeurQrC6Z7c9CoSEraPq2hcn53XE",
  },
};
